import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

const RATIO = 0.09;

export const IconInsuranceBasic = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    // In this icon we use stroke instead of fill
    const currentStroke = isNumber(size) ? `${size * RATIO}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path d="M12.0703 3.11426V3.11328C13.376 3.89181 17.0138 5.51728 18.4258 6.12305L18.5059 6.15723L18.5908 6.17871C18.6244 6.18725 18.6637 6.20498 18.7021 6.23828L18.7402 6.27734C18.7869 6.33171 18.8243 6.40754 18.8428 6.49805C18.891 7.4259 18.9392 8.98612 18.8486 10.6523C18.7604 12.2766 18.5443 13.9135 18.1152 15.1543L18.0273 15.3965C16.725 18.7701 13.1826 20.4301 12.04 20.8867L12.0264 20.8916L12.0137 20.8975C12.0101 20.899 12.0077 20.8992 12.0068 20.8994L12.0049 20.9004H11.998L11.9795 20.8955L11.9707 20.8926L11.7295 20.7949C10.4363 20.2522 7.39181 18.6777 6.08789 15.7168L5.95898 15.4062C5.47092 14.1413 5.23141 12.3947 5.14258 10.665C5.05488 8.95701 5.11867 7.36384 5.1875 6.46094L5.19043 6.41895V6.35547C5.1878 6.36051 5.19168 6.35058 5.21875 6.32715C5.24824 6.30165 5.29371 6.27053 5.35938 6.23633C5.42568 6.2018 5.4925 6.17379 5.57617 6.13965L5.58398 6.13574L5.5918 6.13281C7.00312 5.53099 10.688 3.89924 11.9834 3.11328C12.0026 3.10189 12.0169 3.09965 12.0264 3.09961C12.0359 3.09961 12.0505 3.10248 12.0703 3.11426Z" />
      </svg>
    );
  }
);
